import type {
  ConfiguratorOption,
  ConfiguratorOptionItem,
  ConfiguratorOptionItemFabric,
  ConfiguratorTab,
} from '@Pages/PageProduct';
import type { FilterResultData } from '@Api/Configurator/getFilterResult';

export interface Props {
  tabs: ConfiguratorTab[];
  inStock: boolean;
  currentInStock?: boolean;
  filters?: FilterResultData;
  isBasic?: boolean;
}

function isItemInStock(item: ConfiguratorOptionItem): boolean {
  return item.isInStock;
}

function getInStockCount(options: ConfiguratorOption[]): number {
  return options.reduce((total, option) => {
    return total + option.items.filter(isItemInStock).length;
  }, 0);
}

function processOptions(
  options: ConfiguratorOption[],
  inStock: boolean,
  currentInStock: boolean,
  isColorTab: boolean,
) {
  return options.map((option) => {
    return {
      ...option,
      hidden: inStock && isColorTab ? option.items.every((item) => !isItemInStock(item)) : false,
      items: option.items.map((item) => {
        return {
          ...item,
          hidden: isColorTab && inStock ? !isItemInStock(item) : false,
          calcDisabled: !isColorTab && currentInStock && inStock && !item.selected,
        };
      }),
    };
  });
}

function getTotalItemsCount(options: ConfiguratorOption[]) {
  return options.reduce((total, option) => {
    return total + (option.items ? option.items.length : 0);
  }, 0);
}

function filterInStock(props: Props) {
  const { tabs, inStock, currentInStock, filters, isBasic } = props;

  return tabs.map((tab) => {
    const inStockCount = getInStockCount(tab.options);
    const isColorTab = tab.id === 'color' || tab.id === 'fabric' || tab.id === 'upholstery';
    let count = tab.count;

    if (isColorTab) {
      count = inStock ? inStockCount : getTotalItemsCount(tab.options);
    }

    if (!!tab.filtersInfo && filters) {
      if (tab.id !== 'upholstery') {
        return {
          ...tab,
          options: tab.options.map((option) => ({
            ...option,
            items: option.items.map((item) => ({
              ...item,
              calcDisabled: inStock && isBasic ? item.disabled : false,
              selected: inStock && isBasic ? !item.disabled : item.selected,
            })),
          })),
        };
      }

      return {
        ...tab,
        filtersInfo: filters.filters,
        count: filters.filters?.totalCount || getTotalItemsCount(tab.options),
        options: tab.options.map((option) => ({
          ...option,
          hidden: !filters.fabricCollections.some(
            (collection) => collection.id.toString() === option.id.toString(),
          ),

          items: option.items.map(
            (item) =>
              ({
                ...item,
                collectionTitle: option.title,
                type: 'fabric',
                hidden: !filters.parameterValues.some((parameter) => {
                  if (parameter.tags?.collectionId === 'outlet') {
                    return parameter.shopProductId === item.shopProductId;
                  }
                  return parameter.value === item.id;
                }),
              } as ConfiguratorOptionItemFabric),
          ),
        })),
      };
    }

    return {
      ...tab,
      count,
      options: processOptions(tab.options, inStock, currentInStock, isColorTab),
    };
  });
}

export default filterInStock;
